import { Component } from 'preact'

class PageInfo extends Component {
  constructor () {
    super()
    this.state = { isValid: true }
    this.validate = this.validate.bind(this)
  }

  validate (page, totalPages, callback) {
    const isValid = page > 0 && page <= totalPages
    this.setState({ isValid })
    if (page && isValid) callback(page)
  }

  render (props, state) {
    const { totalPages, currentPage, onPageChange } = props
    const { isValid } = state

    return (
      <div className='control-pagination--pager-item'>
        <span>Page
          <input
            className={`control-pagination--current-page ${!isValid ? 'invalid' : ''}`}
            type={'text'}
            value={currentPage}
            onChange={(e) => {
              const page = parseInt(e.target.value)
              this.validate(page, totalPages, onPageChange)
            }}
          />
            of <strong>{totalPages}</strong>
        </span>
      </div>
    )
  }
}

export default PageInfo
